import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog'; 
import { Router } from '@angular/router';
import { EventEmitterService } from 'src/app/shared/services/events/event-emitter.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';

@Component({
  selector: 'app-confirm-cart-product',
  templateUrl: './confirm-cart-product.component.html',
  styleUrls: ['./confirm-cart-product.component.less']
})
export class ConfirmCartProductComponent implements OnInit {
  product: any = {};
  isMobile: boolean = false;
  height: number;
  userType:string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private utils: UtilsService,
    private eventEmitterService: EventEmitterService
  ) {
    this.isMobile = window.innerWidth <= 768;
    this.height = window.innerHeight;

  }
  get canSeeDesignPricing(){
    const userType = ''+this.userType
    return (userType == '2' || userType == '70' || userType == '90' )&& 
    (this.data?.product_data?.inventory_product_details.design_price ||   (
      this.data?.product_data?.design_min_price ||this.data?.product_data?.design_max_price &&
      (this.data?.product_data?.design_min_price!==0 ||
    this.data?.product_data?.design_max_price!==0)))  
  }

  get canSeeDesignPricingFromSelection(){
    const userType = ''+this.userType
    return (userType == '2' || userType == '70' || userType == '90' )&& 
    this.data?.designPriceFromSelection>0
  }

     @HostListener('window:resize', ['$event'])
      onResize(event) {
          this.isMobile = window.innerWidth <= 768;
    this.height = window.innerHeight;
      }

      ngOnInit() {
    this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;
    this.product = this.data;
    
    this.utils.updateLocalCart(this.product.quantity);
    this.eventEmitterService.updateCartIcon();
  }

  closeAllDialogs() {
    this.router.navigate(['cart']).then(() => {
      location.reload();
    });
  }

  get containerHeight(){
    return document.getElementById('containerHeight').clientHeight;
  }
}
